import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import MonitorOptions from "./MonitorOptions";
import WeatherIcon from "../../assets/icons/Icon_Library/application icons/monitoring/monitor_types/mon_weather.svg2";
import WelfareIcon from "../../assets/icons/Icon_Library/application icons/monitoring/monitor_types/mon_welfare-01.svg2";
import RemoteLocationsIcon from "../../assets/icons/Icon_Library/application icons/monitoring/monitor_types/mon_remote_devices-01.svg2";
import EnvironmentalIcon from "../../assets/icons/Icon_Library/application icons/monitoring/monitor_types/mon_environmental_conditions-01.svg2";
import InfrastructureIcon from "../../assets/icons/Icon_Library/application icons/monitoring/industries/industry_construction-01.svg2";
import HumanIcon from "../../assets/icons/Icon_Library/application icons/assets/events/asset_events/human-01.svg2";
import MobileIcon from "../../assets/icons/icon_mobile_number-01.svg2";
import AlertIcon from "../../assets/icons/Icon_Library/application icons/monitoring/icon_alert.svg2";
import HeartbeatIcon from "../../assets/icons/Icon_Library/application icons/monitoring/icon_heartbeat_1.svg2";
import PingIcon from "../../assets/icons/Icon_Library/application icons/monitoring/icon_ping .svg2";
import MonitorDetails from "./MonitorDetails";

export const whatToMonitorOptions = [
  {
    name: "weather",
    kind: "weather",
    heading: "Weather",
    icon: WeatherIcon,
    info: (
      <div>
        <div className="fw-bold">Weather Monitoring</div>
        <div className="text-secondary">
          Track live weather conditions and forecasts to anticipate
          environmental impacts on your operations. Monitor temperature, wind,
          precipitation, and severe weather alerts to improve safety, planning,
          and response times.
        </div>
      </div>
    ),
    isDisabled: false,
  },
  {
    name: "ping",
    kind: "ping",
    heading: "Ping",
    icon: PingIcon,
    info: (
      <div>
        <div className="fw-bold">Ping</div>
        <div className="text-secondary">
          Boomerang makes an outbound request to an external resource (endpoint
          / port / device etc.) to verify access, availability, performance /
          latency etc
        </div>
      </div>
    ),
    isDisabled: false,
  },
  {
    name: "Infrastructure",
    kind: "Infrastructure",
    heading: "Infrastructure",
    icon: InfrastructureIcon,
    info: (
      <div>
        <div className="fw-bold">Infrastructure</div>
        <div className="text-secondary">
          Monitor system health, security, and performance in real time—covering
          security alarms, server health, network activity, and environmental
          conditions to keep operations running smoothly.
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },
  {
    name: "heartbeat",
    kind: "heartbeat",
    heading: "Heartbeat",
    icon: HeartbeatIcon,
    info: (
      <div>
        <div className="fw-bold">Heartbeat</div>
        <div className="text-secondary">
          Requests are received at scheduled intervals from an external source
          and failure to receive a request when expected, is used as the trigger
          to activate a workflow
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },
  {
    name: "alert",
    kind: "alert",
    heading: "Alert",
    icon: AlertIcon,
    info: (
      <div>
        <div className="fw-bold">Alert</div>
        <div className="text-secondary">
          Monitoring alerts are received from an external source (e.g.
          monitoring software) and used to trigger a workflow
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },
  {
    name: "Mobile Assets",
    kind: "Mobile Assets",
    heading: "Mobile Assets",
    icon: MobileIcon,
    info: (
      <div>
        <div className="fw-bold">Mobile Assets</div>
        <div className="text-secondary">
          Track and manage vehicles, equipment, and other moving resources in
          real time. Monitor location, status, and usage to improve efficiency,
          security, and operational control.
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },
  {
    name: "Human Resource",
    kind: "Human Resource",
    heading: "Human Resource",
    icon: HumanIcon,
    info: (
      <div>
        <div className="fw-bold">About Human Resource</div>
        <div className="text-secondary">
          Monitor and support your workforce, including lone workers, by
          tracking real-time locations, assigned tasks, and response times.
          Ensure personnel are safe, productive, and connected—no matter where
          they are.
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },

  {
    name: "welfare",
    kind: "welfare",
    heading: "Welfare",
    icon: WelfareIcon,
    info: (
      <div>
        <div className="fw-bold">Welfare</div>
        <div className="text-secondary">
          Ensure the safety and well-being of all personnel, including lone
          workers, through real-time monitoring of health, comfort, and working
          conditions. Track environmental factors, send emergency alerts, and
          enable rapid response to incidents.
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },
  {
    name: "remoteDevicesAndLocations",
    kind: "remoteDevicesAndLocations",
    heading: "Remote devices and locations",
    icon: RemoteLocationsIcon,
    info: (
      <div>
        <div className="fw-bold">Remote devices and locations</div>
        <div className="text-secondary">
          Monitor and manage devices and sites from anywhere, including security
          cameras, environmental sensors, power systems, and communication
          equipment. Track performance, security, and conditions to ensure
          smooth operations and quick issue resolution.
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },
  {
    name: "environnementalConditions",
    kind: "environnemental conditions",
    heading: "Environmental conditions",
    icon: EnvironmentalIcon,
    info: (
      <div className="text-start">
        <div className="fw-bold">Environmental conditions</div>
        <div className="text-secondary ">
          Track factors such as temperature, humidity, air quality, and noise
          levels to ensure safe and optimal working environments. Receive alerts
          for changes that could impact safety, equipment performance, or
          overall operations.
        </div>
      </div>
    ),
    isDisabled: true,
    isNewFeature: true,
  },
];

function MonitoringSetup({ monitor, setMonitor, backendErrors }) {
  return (
    <div>
      <Row className="mt-3">
        <Col xl={5} xs={12} className="border-end ">
          <div className="me-xl-5">
            <MonitorOptions
              whatToMonitor={whatToMonitorOptions.find(
                (o) => o.kind === monitor.Kind
              )}
              setWhatToMonitor={(o) => {
                setMonitor({ ...monitor, Kind: o.kind });
              }}
              disabled={!!monitor.Uuid}
            />
          </div>
        </Col>
        <Col xl={7}>
          <div className="ms-xl-5">
            {monitor.Kind && (
              <MonitorDetails
                monitor={monitor}
                setMonitor={setMonitor}
                backendErrors={backendErrors}
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default MonitoringSetup;
